import React, { useEffect, useContext, useState } from "react";
import { NavLink } from "react-router-dom";
//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";
//functions
import {
    _t,
    getCookie,
    currencySymbolLeft,
    formatPrice,
    currencySymbolRight,
    pageLoading,
    paginationLoading,
    pagination,
    showingData,
    searchedShowingData,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";

//importing context consumer here
import { UserContext } from "../../../../contexts/User";
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";

const Desperdicio = () => {
    //getting context values here
    const {
        //common
        loading,
        setLoading,
    } = useContext(SettingsContext);

    const {
        authUserInfo,
    } = useContext(UserContext);

    const {
        //submitted orders
        submittedOrders,
        setPaginatedSubmittedOrders,
        submittedOrdersForSearch,

        //payment-type
        paymentTypeForSearch,

        //pagination
        dataPaginating,
    } = useContext(RestaurantContext);

    const { t } = useTranslation();

    // States hook here
    // paidMoney
    const [paidMoney, setPaidMoney] = useState(0);
    //return
    const [returnMoneyUsd, setReturnMoneyUsd] = useState(0);

    //settle order
    const [checkOrderDetails, setCheckOrderDetails] = useState({
        item: null,
        settle: false,
        uploading: false,
        payment_type: null,
        payment_amount: null,
    });

    //search result
    const [searchedOrder, setSearchedOrder] = useState({
        list: null,
        searched: false,
    });

    const [dataPaginatingcancelled, setDataPaginatingcancelled] = useState(false);

    const [datatableitems, setdatatableitems] = useState(null);
    const [datatableitemsOrdersForSearch, setdatatableitemsOrdersForSearch] = useState(null);


    const [datatablecard, setdatatablecard] = useState({
        datatablecard: []
    });

    const [datausers, setdatausers] = useState([]);
    const [dataplatillos, setdataplatillos] = useState([]);
    const [dataingredients, setdataingredients] = useState([]);
    const [datavariation, setvariation] = useState([]);

    const [posform, setposform] = useState({
        id: 0,
        user_id: "",
        total_cost: 0,
        note: 0,
        charged_to: 0,
        items: []
    });
    const [btncreate, setbtncreate] = useState(false);
    //useEffect == componentDidMount
    useEffect(() => {

        getdatatableitems();
        getdataslc();

    }, []);

    const getdatatableitems = () => {
        setLoading(true);
        const url = BASE_URL + "/settings/get-desperdicios";
        return axios
            .get(url, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                setdatatableitems(res.data[0]);
                setdatatableitemsOrdersForSearch(res.data[1]);
                setLoading(false);
            });
    };
    const setPaginateddatatableitems = (pageNo) => {
        setDataPaginatingcancelled(true);
        const url = BASE_URL + "/settings/get-desperdicios?page=" + pageNo;
        return axios
            .get(url, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                setdatatableitems(res.data[0]);
                setdatatableitemsOrdersForSearch(res.data[1]);
                setDataPaginatingcancelled(false);
            })
            .catch(() => { });
    };
    //payment type
    const handleSetpaymentType = (payment_type) => {
        setCheckOrderDetails({
            ...checkOrderDetails,
            payment_type,
        });

        //calculate paid amount to set return amount
        handleCalculatePaid(checkOrderDetails.payment_amount, payment_type);
    };

    //payment type amount
    const handlePaymentTypeAmount = (e) => {
        let tempPaymentAmount = {
            ...checkOrderDetails.payment_amount,
            [e.target.name]: e.target.value,
        };

        setCheckOrderDetails({
            ...checkOrderDetails,
            payment_amount: tempPaymentAmount,
        });

        //calculate paid amount to set return amount
        handleCalculatePaid(tempPaymentAmount, checkOrderDetails.payment_type);
    };

    //calculate paid amount
    const handleCalculatePaid = (paymentAmount, paymentType) => {
        let paidAmount = 0;
        if (paymentAmount !== null && paymentType !== null) {
            let thePaymentArray = [];
            if (paymentAmount) {
                thePaymentArray = Object.entries(paymentAmount);
            }
            thePaymentArray.map((eachPaymentItem) => {
                let thePaymentType = paymentType.find((paymentTypeItem) => {
                    return paymentTypeItem.id === parseInt(eachPaymentItem[0]);
                });
                if (eachPaymentItem[1] !== "") {
                    if (
                        thePaymentType &&
                        thePaymentType.id === parseInt(eachPaymentItem[0])
                    ) {
                        paidAmount = paidAmount + parseFloat(eachPaymentItem[1]);
                    }
                }
            });
            let localCurrency = JSON.parse(localStorage.getItem("currency"));
            paidAmount = paidAmount / localCurrency.rate;
            let theReturnMoney = 0;
            if (checkOrderDetails.item) {
                theReturnMoney =
                    paidAmount - parseFloat(checkOrderDetails.item.total_payable);
            }
            setReturnMoneyUsd(theReturnMoney);
        } else {
            setReturnMoneyUsd(0);
        }
        setPaidMoney(paidAmount);
    };
    // handleSettleOrder
    const handleSettleOrder = (e) => {
        e.preventDefault();
        if (
            paidMoney <
            parseFloat(
                checkOrderDetails.item.total_payable -
                checkOrderDetails.item.paid_amount
            )
        ) {
            toast.error(
                `${_t(
                    t("Please enter paid amount atleast equal to the total due amount")
                )}`,
                {
                    position: "bottom-center",
                    closeButton: false,
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                }
            );
        } else {
            handleSettleOrderAxiosReq();
        }
    };
    //settle order server request
    const handleSettleOrderAxiosReq = () => {
        let url = BASE_URL + "/settings/settle-submitted-order";
        let localCurrency = JSON.parse(localStorage.getItem("currency"));
        let formData = {
            order_group_id: checkOrderDetails.item.id,
            payment_type: checkOrderDetails.payment_type,
            payment_amount: checkOrderDetails.payment_amount,
            paidMoney: paidMoney,
            localCurrency: localCurrency,
        };
        setLoading(true);
        axios
            .post(url, formData, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                if (res.data !== "paymentIssue") {
                    setCheckOrderDetails({
                        ...checkOrderDetails,
                        item: res.data[2],
                        payment_type: null,
                        payment_amount: null,
                        settle: false,
                    });
                    setSearchedOrder({
                        ...searchedOrder,
                        searched: false,
                    });
                    setLoading(false);
                } else {
                    setLoading(false);
                    toast.error(
                        `${_t(
                            t(
                                "Please enter paid amount atleast equal to the total due amount"
                            )
                        )}`,
                        {
                            position: "bottom-center",
                            closeButton: false,
                            autoClose: 10000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            className: "text-center toast-notification",
                        }
                    );
                }
            })
            .catch(() => {
                setLoading(false);
                toast.error(`${_t(t("Please try again"))}`, {
                    position: "bottom-center",
                    closeButton: false,
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                });
            });
    };
    //search submitted orders here
    const handleSearch = (e) => {
        let searchInput = e.target.value.toLowerCase();
        if (searchInput.length === 0) {
            setSearchedOrder({ ...searchedOrder, searched: false });
        } else {
            let searchedList = datatableitemsOrdersForSearch.filter((item) => {
                //token
                let lowerCaseItemToken = JSON.stringify(item.id);

                //customer
                let lowerCaseItemCustomer = item.charged_to_name.toLowerCase();

                //table
                //let lowerCaseItemTable = item.table_name.toLowerCase();

                //branch
                //let lowerCaseItemBranch = item.branch_name.toLowerCase();
                return (
                    lowerCaseItemToken.includes(searchInput) ||
                    lowerCaseItemCustomer.includes(searchInput)
                    //lowerCaseItemTable.includes(searchInput) ||
                    //(lowerCaseItemBranch && lowerCaseItemBranch.includes(searchInput))
                );
            });
            setSearchedOrder({
                ...searchedOrder,
                list: searchedList,
                searched: true,
            });
        }
    };
    //cancel order confirmation modal
    const handleCancelOrderConfirmation = (orderGroup) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="card card-body">
                        <h1>{_t(t("Are you sure?"))}</h1>
                        <p className="text-center">
                            {_t(t("You want to cancel this order?"))}
                        </p>
                        <div className="d-flex justify-content-center">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    handleCancelOrder(orderGroup);
                                    onClose();
                                }}
                            >
                                {_t(t("Yes, cancel it!"))}
                            </button>
                            <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                                {_t(t("No"))}
                            </button>
                        </div>
                    </div>
                );
            },
        });
    };
    //cancel order here
    const handleCancelOrder = (orderGroup) => {
        if (parseInt(orderGroup.is_accepted) === 0) {
            let url = BASE_URL + "/settings/cancel-submitted-order";
            let formData = {
                id: orderGroup.id,
            };
            setLoading(true);
            axios
                .post(url, formData, {
                    headers: { Authorization: `Bearer ${getCookie()}` },
                })
                .then((res) => {
                    setLoading(false);
                    if (res.data === "accepted") {
                        toast.error(
                            `${_t(t("Can not cancel this order, this is being cooked"))}`,
                            {
                                position: "bottom-center",
                                closeButton: false,
                                autoClose: 10000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                className: "text-center toast-notification",
                            }
                        );
                    }
                })
                .catch(() => {
                    setLoading(false);
                    toast.error(`${_t(t("Please try again"))}`, {
                        position: "bottom-center",
                        closeButton: false,
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                    });
                });
        } else {
            toast.error(
                `${_t(t("Can not cancel this order, this is being cooked"))}`,
                {
                    position: "bottom-center",
                    closeButton: false,
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                }
            );
        }
    };
    //desperdicio
    const handleonchangueposform = (e) => {
        setposform({ ...posform, [e.target.name]: e.target.value });
    };
    const handleposform = (e) => {
        e.preventDefault();
        if (posform.charged_to == 0) {
            toast.error(`${_t(t("Ingresar Persona responsable"))}`, {
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
        } else {
            let dt = {
                user_id: authUserInfo.details.id,
                branch_id: authUserInfo.details.branch_id,
                total_cost: posform.total_cost,
                note: posform.note,
                charged_to: posform.charged_to,
                items: datatablecard.datatablecard,
            }
            if (datatablecard.length == 0) {
                toast.error(`${_t(t("Favor agregar ingredientes o platillos"))}`, {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                });
            } else {
                const foodUnitUrl = BASE_URL + `/settings/post-desperdicio`;

                return axios
                    .post(foodUnitUrl, dt, {
                        headers: { Authorization: `Bearer ${getCookie()}` },
                    })
                    .then((res) => {
                        toast.success(`${_t(t("Desperdicio Almacenado"))}`, {
                            position: "bottom-center",
                            autoClose: 10000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            className: "text-center toast-notification",
                        });
                        getdatatableitems();
                    })
                    .catch((error) => {

                    });
            }
        }
    };
    const handlesetslccharged = (row) => {
        setposform({
            ...posform,
            charged_to: row.id
        });
    };
    const getdataslc = () => {
        setLoading(true);
        let formData = {
            branch_id: authUserInfo.details.branch_id,
            user_id: authUserInfo.details.id,
        };
        const customerUrl = BASE_URL + "/settings/get-data-slc";
        return axios
            .get(customerUrl, {
                params: formData,
                headers: { Authorization: `Bearer ${getCookie()}` },
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            .then((res) => {
                /*setdatadetallecaja(res.data[0][0]);
                setdatausers(res.data[1]);*/
                setdatausers(res.data[1]);
                setdataplatillos(res.data[3]);
                setdataingredients(res.data[0]);
                setLoading(false);
            });
    };
    const handleaddingredients_items = (row) => {
        console.log(datatablecard.length)
        if (row.target.type == 2) {
            setvariation(row.target.value.variations);
        } else {
            let newitem = {
                id: 0,
                variation_id: 0,
                item_id: row.target.value.id,
                name: row.target.value.name,
                amount: 0,
                type: row.target.type,
                cost_unit: row.target.type == 2 ? 0 : row.target.value.cost,
                cost_total: 0,
            }
            let total = 0;
            if (datatablecard.length != 0) {
                let ingredientTemp = null; //to edit selected item
                let ingredient = []; //array to push order items

                datatablecard.datatablecard.map((newOrderItem, index) => {
                    if (index == 0) {
                        ingredient.push(newitem);
                    };

                    ingredientTemp = {
                        ...newOrderItem
                    };

                    ingredient.push(newOrderItem);
                    total = total + (newOrderItem.cost_unit * newOrderItem.amount)
                });

                setdatatablecard({ ...datatablecard, datatablecard: ingredient });
            } else {
                let ingredient = []; //array to push order items
                ingredient.push(newitem);
                total = total + (newitem.amount * newitem.cost_unit)
                setdatatablecard({ ...datatablecard, datatablecard: ingredient });
            }
            handledatatablecard(total);
        }
    };
    const handleonchangeamount = (e) => {
        console.log(datatablecard)
        if (datatablecard.datatablecard) {
            let ingredientTemp = null; //to edit selected item
            let ingredient = []; //array to push order items
            let total = 0;
            datatablecard.datatablecard.map((newOrderItem, index) => {
                if (index == e.target.name) {
                    total = total + (e.target.value * newOrderItem.cost_unit)

                    ingredientTemp = {
                        ...newOrderItem,
                        amount: e.target.value,
                        cost_total: e.target.value * newOrderItem.cost_unit
                    };
                    ingredient.push(ingredientTemp);

                } else {
                    total = total + (newOrderItem.cost_unit * newOrderItem.amount)
                    ingredient.push(newOrderItem);
                }
            });
            setdatatablecard({ ...datatablecard, datatablecard: ingredient });
            handledatatablecard(total);
        }
    };
    const handleDeleteitemcard = (removeIndex) => {
        //setLoading(true);
        let oldOrderItems = []; //array to push order items
        datatablecard.datatablecard.map((newOrderItem, index) => {
            if (index !== removeIndex) {
                //push item to orderlist
                oldOrderItems.push(newOrderItem);
            } else {
                if (newOrderItem.id != 0) {

                }

            }
        });
        setdatatablecard({ ...datatablecard, datatablecard: oldOrderItems });
    };
    const handleaddingredients_items_variation = (row) => {
        let newitem = {
            variation_id: row.target.value.id,
            id: 0,
            item_id: row.target.value.food_item,
            name: row.target.value.food_item_name + "(" + row.target.value.name + ")",
            amount: 0,
            type: row.target.type,
            cost_unit: row.target.value.cost_total,
            cost_total: 0,
        }
        let total = 0;
        if (datatablecard.length != 0) {
            let ingredientTemp = null; //to edit selected item
            let ingredient = []; //array to push order items

            datatablecard.datatablecard.map((newOrderItem, index) => {
                if (index == 0) {
                    ingredient.push(newitem);
                };

                ingredientTemp = {
                    ...newOrderItem
                };

                ingredient.push(newOrderItem);
                total = total + (newOrderItem.cost_unit * newOrderItem.amount)
            });

            setdatatablecard({ ...datatablecard, datatablecard: ingredient });
        } else {
            let ingredient = []; //array to push order items
            ingredient.push(newitem);
            total = total + (newitem.amount * newitem.cost_unit)
            setdatatablecard({ ...datatablecard, datatablecard: ingredient });
        }
        setvariation([]);
        handledatatablecard(total);
    };
    const handledatatablecard = (total) => {
        setposform({ ...posform, total_cost: total });
    };
    const handlesetdataeditcard = (row) => {
        console.log(row)
        setposform({ ...posform, id: row.id });
        setdatatablecard({ ...datatablecard, datatablecard: row.items });
    };
    const handleeditform = (e) => {
        e.preventDefault();
        if (posform.charged_to == 0) {
            toast.error(`${_t(t("Ingresar Persona responsable"))}`, {
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
        } else {
            let dt = {
                user_id: authUserInfo.details.id,
                branch_id: authUserInfo.details.branch_id,
                total_cost: posform.total_cost,
                note: posform.note,
                charged_to: posform.charged_to,
                id: posform.id,
                items: datatablecard.datatablecard,
            }
            if (datatablecard.datatablecard.length == 0) {
                toast.error(`${_t(t("Favor agregar ingredientes o platillos"))}`, {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                });
            } else {
                const foodUnitUrl = BASE_URL + `/settings/edit-desperdicio`;

                return axios
                    .post(foodUnitUrl, dt, {
                        headers: { Authorization: `Bearer ${getCookie()}` },
                    })
                    .then((res) => {
                        toast.success(`${_t(t("Desperdicio actualizado"))}`, {
                            position: "bottom-center",
                            autoClose: 10000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            className: "text-center toast-notification",
                        });
                        getdatatableitems();
                    })
                    .catch((error) => {

                    });
            }
        }
    };

    return (
        <>
            <Helmet>
                <title>{_t(t("Desperdicios"))}</title>
            </Helmet>

            {/* Settle modal */}
            <div className="modal fade" id="modalcreate" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header align-items-center">
                            <div className="fk-sm-card__content">
                                <h5 className="text-capitalize fk-sm-card__title">Desperdicios</h5>
                            </div>
                            <button
                                type="button"
                                className="btn-close"
                                data-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        {/* if loading true show loading effect */}
                        <div className="modal-body">
                            <div className="row gx-2 align-items-center t-pt-15 t-pb-15 t-pl-15 t-pr-15 t-shadow">
                                <div className="col-6 t-mb-15" style={{ textAlign: "left" }}>
                                    <label htmlFor="Total" className="form-label">
                                        {_t(t("Total"))}{" "}
                                    </label>
                                </div>
                                <div className="col-6 t-mb-15" style={{ textAlign: "right" }}>
                                    <label htmlFor="t" className="form-label">
                                        {posform.total_cost}
                                    </label>
                                </div>
                            </div>
                            <br />

                            <form onSubmit={btncreate ? handleposform : handleeditform} className="mx-2 sm-text">
                                <div className="row gx-2 align-items-center t-pt-15 t-pb-15 t-pl-15 t-pr-15">
                                    <div className="col-12 t-mb-15" style={{ textAlign: "left" }}>
                                        <div className="form-group">
                                            <div className="mb-2">
                                                <label className="control-label">
                                                    {_t(t("Persona Responsable"))}
                                                </label>
                                            </div>
                                            <div className="mb-2">
                                                {datausers && (
                                                    <ul className="list-group list-group-horizontal-sm row col-12 mb-2 ml-md-1">
                                                        {datausers.map((selectedItem) => {
                                                            if (selectedItem.id == posform.charged_to) {
                                                                return (
                                                                    <li className="list-group-item col-12 col-md-3 bg-success rounded-sm py-1 px-2 mx-2 my-1 text-center">
                                                                        {selectedItem.name}
                                                                    </li>
                                                                );
                                                            }

                                                        })}
                                                    </ul>
                                                )}
                                                <Select
                                                    options={datausers}
                                                    components={makeAnimated()}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.name}
                                                    classNamePrefix="select"
                                                    className="xsm-text"
                                                    onChange={handlesetslccharged}
                                                    maxMenuHeight="200px"
                                                    placeholder={_t(t("Usuarios")) + ".."}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{ textAlign: "left" }}>
                                        <div className="col-md-6" style={{ textAlign: "left" }}>
                                            <div className="form-group">
                                                <div className="mb-2">
                                                    <label className="control-label">
                                                        {_t(t("Ingredientes"))}
                                                    </label>
                                                </div>
                                                <div className="mb-2">
                                                    <Select
                                                        options={dataingredients}
                                                        components={makeAnimated()}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.name}
                                                        classNamePrefix="select"
                                                        className="xsm-text"
                                                        //onChange={handleaddingredients_items()}
                                                        onChange={(val) => { handleaddingredients_items({ target: { type: 1, value: val } }) }}
                                                        maxMenuHeight="200px"
                                                        placeholder={_t(t("Ingredientes")) + ".."}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6" style={{ textAlign: "left" }}>
                                            <div className="form-group">
                                                <div className="mb-2">
                                                    <label className="control-label">
                                                        {_t(t("Platillos"))}
                                                    </label>
                                                </div>
                                                <div className="mb-2">
                                                    <Select
                                                        options={dataplatillos}
                                                        components={makeAnimated()}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.name}
                                                        classNamePrefix="select"
                                                        className="xsm-text"
                                                        //onChange={handleaddingredients_items(2)}
                                                        onChange={(val) => { handleaddingredients_items({ target: { type: 2, value: val } }) }}
                                                        maxMenuHeight="200px"
                                                        placeholder={_t(t("Platillos")) + ".."}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 t-mb-15" style={{ textAlign: "left" }}>
                                            <textarea
                                                className="form-control"
                                                placeholder="note"
                                                name="note"
                                                value={posform && posform.note}
                                                onChange={handleonchangueposform}>
                                            </textarea>
                                        </div>
                                    </div>
                                    <div className="row" style={{ textAlign: "left" }}>
                                        <div className="col-md-6" style={{ textAlign: "left" }}>
                                            <div className="form-group">
                                                <div className="mb-2">
                                                    <label className="control-label">
                                                        {_t(t("Variacion"))}
                                                    </label>
                                                </div>
                                                <div className="mb-2">
                                                    <Select
                                                        options={datavariation}
                                                        components={makeAnimated()}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.name}
                                                        classNamePrefix="select"
                                                        className="xsm-text"
                                                        //onChange={handleaddingredients_items()}
                                                        onChange={(val) => { handleaddingredients_items_variation({ target: { type: 2, value: val } }) }}
                                                        maxMenuHeight="200px"
                                                        placeholder={_t(t("Variacion")) + ".."}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6" style={{ textAlign: "left" }}>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                        </div>
                                        <div className="col-6">
                                            <button
                                                type="submit"
                                                className="btn btn-success w-100 xsm-text text-uppercase t-width-max"
                                            >
                                                {btncreate ? 'Guardar' : 'Editar'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover">
                                    <thead className="align-middle">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="sm-text align-middle text-center border-1 border"
                                            >
                                                {_t(t("S/L"))}
                                            </th>

                                            <th
                                                scope="col"
                                                className="sm-text align-middle text-center border-1 border"
                                            >
                                                {_t(t("Nombre"))}
                                            </th>
                                            <th
                                                scope="col"
                                                className="sm-text align-middle text-center border-1 border"
                                            >
                                                {_t(t("Cantidad"))}
                                            </th>
                                            <th
                                                scope="col"
                                                className="sm-text align-middle text-center border-1 border"
                                            >
                                                {_t(t("Costo"))}
                                            </th>
                                            <th
                                                scope="col"
                                                className="sm-text align-middle text-center border-1 border"
                                            >
                                                {_t(t("Accion"))}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {datatablecard.datatablecard && datatablecard.datatablecard.length > 0 ? (
                                            [
                                                datatablecard.datatablecard.map((item, index) => {
                                                    return (
                                                        <tr
                                                            scope="row"
                                                            className="xsm-text align-middle text-center"
                                                        >
                                                            <td className="xsm-text text-capitalize align-middle text-center">
                                                                {index + 1}
                                                            </td>
                                                            <td className="xsm-text text-capitalize align-middle text-center">
                                                                {item.name}
                                                            </td>
                                                            <td className="xsm-text text-capitalize align-middle text-center   text-secondary">
                                                                <input
                                                                    type="number"
                                                                    min="0"
                                                                    style={{ width: "50px" }}
                                                                    name={index}
                                                                    value={item.amount}
                                                                    onChange={(e) => {
                                                                        handleonchangeamount(e);
                                                                    }}
                                                                    className="form-control xsm-text text-center variation-min-price-input-width"
                                                                    placeholder="Ingrese Costo"
                                                                />
                                                            </td>
                                                            <td className="xsm-text text-capitalize align-middle text-center  text-primary">
                                                                {item.amount * item.cost_unit}
                                                            </td>
                                                            <td className="xsm-text text-capitalize align-middle text-center">
                                                                <button
                                                                    className="btn t-bg-clear t-text-dark--light-40   text-primary"
                                                                    type="button"
                                                                    onClick={() =>
                                                                        handleDeleteitemcard(index)
                                                                    }
                                                                >
                                                                    <i className="fa fa-trash-o"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                }),
                                            ]
                                        ) : null}
                                    </tbody>
                                </table>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            {/* Settle modal Ends*/}

            {/* main body */}
            <main id="main" data-simplebar>
                <div className="container">
                    <div className="row t-mt-10 gx-2">
                        {/* left Sidebar */}
                        <div className="col-12 t-mb-30 mb-lg-0">
                            {checkOrderDetails.uploading === true || loading === true ? (
                                pageLoading()
                            ) : (
                                <div className="t-bg-white ">
                                    {/* next page data spin loading */}
                                    <div className={`${dataPaginating && "loading"}`}></div>
                                    {/* spin loading ends */}
                                    <div className="row gx-2 align-items-center t-pt-15 t-pb-15 t-pl-15 t-pr-15 t-shadow">
                                        <div className="col-12 t-mb-15">
                                            <ul className="t-list fk-breadcrumb">
                                                <li className="fk-breadcrumb__list">
                                                    <span className="t-link fk-breadcrumb__link text-capitalize">
                                                        {!searchedOrder.searched
                                                            ? _t(t("Desperdicios"))
                                                            : _t(t("Search Result"))}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                                            <ul className="t-list fk-sort align-items-center">
                                                <div className="input-group col">
                                                    <div className="form-file">
                                                        <input
                                                            type="text"
                                                            className="form-control border-0 form-control--light-1 rounded-0"
                                                            placeholder={
                                                                _t(t("Busqueda por id, cliente")) +
                                                                ".."
                                                            }
                                                            onChange={handleSearch}
                                                        />
                                                    </div>
                                                    <button className="btn btn-primary" type="button">
                                                        <i className="fa fa-search" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 col-lg-5">
                                            <div className="col-md-6 col-lg-7 t-mb-15 mb-md-0">
                                                <div className="row gx-2 align-items-center">
                                                    <div className="col-12 col-md-5 ml-auto mt-2 mt-md-0">
                                                        <ul className="t-list fk-sort align-items-center justify-content-center">
                                                            <li className="fk-sort__list mb-0 flex-grow-1">
                                                                <button
                                                                    className="w-100 btn btn-secondary sm-text text-uppercase"
                                                                    data-toggle="modal"
                                                                    data-target="#modalcreate"
                                                                    onClick={() => {
                                                                        setbtncreate(true);
                                                                        setdatatablecard([]);
                                                                        setposform({
                                                                            id: 0,
                                                                            user_id: 0,
                                                                            total_cost: 0,
                                                                            note: "",
                                                                            charged_to: 0,
                                                                            items: []
                                                                        });
                                                                    }}
                                                                >
                                                                    {_t(t("add new"))}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="fk-scroll--order-history" data-simplebar>
                                        <div className="t-pl-15 t-pr-15">
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-hover min-table-height mt-4">
                                                    <thead className="align-middle">
                                                        <tr>
                                                            <th
                                                                scope="col"
                                                                className="sm-text text-capitalize align-middle text-center border-1 border"
                                                            >
                                                                {_t(t("S/L"))}
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                className="sm-text text-capitalize align-middle text-center border-1 border"
                                                            >
                                                                {_t(t("Cargado a"))}
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="sm-text text-capitalize align-middle text-center border-1 border"
                                                            >
                                                                {_t(t("Total"))}
                                                            </th>
                                                            <th
                                                                scope="col"
                                                                className="sm-text text-capitalize align-middle text-center border-1 border"
                                                            >
                                                                {_t(t("nota"))}
                                                            </th>

                                                            <th
                                                                scope="col"
                                                                className="sm-text text-capitalize align-middle text-center border-1 border"
                                                            >
                                                                {_t(t("Detalle"))}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="align-middle">
                                                        {/* loop here, logic === !search && haveData && haveDataLegnth > 0*/}
                                                        {!searchedOrder.searched
                                                            ? [
                                                                datatableitems && [
                                                                    datatableitems.data.length === 0 ? (
                                                                        <tr className="align-middle">
                                                                            <td
                                                                                scope="row"
                                                                                colSpan="8"
                                                                                className="xsm-text align-middle text-center"
                                                                            >
                                                                                {_t(t("No data available"))}
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        datatableitems.data.map(
                                                                            (item, index) => {
                                                                                return (
                                                                                    <tr
                                                                                        className="align-middle"
                                                                                        key={index}
                                                                                    >
                                                                                        <th
                                                                                            scope="row"
                                                                                            className="xsm-text text-capitalize align-middle text-center"
                                                                                        >
                                                                                            {item.id}
                                                                                        </th>

                                                                                        <td className="xsm-text text-capitalize align-middle text-center text-secondary">
                                                                                            {item.charged_to_name}
                                                                                        </td>

                                                                                        <td className="xsm-text text-capitalize align-middle text-center">

                                                                                            <span className="btn btn-transparent btn-primary xsm-text text-capitalize px-3">
                                                                                                {currencySymbolLeft()}
                                                                                                {formatPrice(item.total_cost)}
                                                                                                {currencySymbolRight()}
                                                                                            </span>
                                                                                        </td>

                                                                                        <td className="xsm-text text-capitalize align-middle text-center text-secondary">
                                                                                            {item.note}
                                                                                        </td>

                                                                                        <td className="xsm-text text-capitalize align-middle text-center">
                                                                                            {
                                                                                                <span
                                                                                                    className="btn btn-transparent btn-secondary xsm-text text-capitalize"
                                                                                                    onClick={() => {
                                                                                                        handlesetdataeditcard(item)
                                                                                                        setbtncreate(false);
                                                                                                        setposform({
                                                                                                            id: item.id,
                                                                                                            user_id: 0,
                                                                                                            total_cost: item.total_cost,
                                                                                                            note: item.note,
                                                                                                            charged_to: item.charged_to,
                                                                                                            items: []
                                                                                                        });
                                                                                                    }}
                                                                                                    data-toggle="modal"
                                                                                                    data-target="#modalcreate"
                                                                                                >
                                                                                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                                                                                </span>}
                                                                                        </td>

                                                                                    </tr>
                                                                                );
                                                                            }
                                                                        )
                                                                    ),
                                                                ],
                                                            ]
                                                            : [
                                                                /* searched data, logic === haveData*/
                                                                searchedOrder && [
                                                                    searchedOrder.list.length === 0 ? (
                                                                        <tr className="align-middle">
                                                                            <td
                                                                                scope="row"
                                                                                colSpan="8"
                                                                                className="xsm-text align-middle text-center"
                                                                            >
                                                                                {_t(t("No data available"))}
                                                                            </td>
                                                                        </tr>
                                                                    ) : (
                                                                        searchedOrder.list.map((item, index) => {
                                                                            return (
                                                                                <tr
                                                                                    className="align-middle"
                                                                                    key={index}
                                                                                >
                                                                                    <th
                                                                                        scope="row"
                                                                                        className="xsm-text text-capitalize align-middle text-center"
                                                                                    >
                                                                                        {item.id}
                                                                                    </th>

                                                                                    <td className="xsm-text text-capitalize align-middle text-center text-secondary">
                                                                                        {item.charged_to_name}
                                                                                    </td>

                                                                                    <td className="xsm-text text-capitalize align-middle text-center">

                                                                                        <span className="btn btn-transparent btn-primary xsm-text text-capitalize px-3">
                                                                                            {currencySymbolLeft()}
                                                                                            {formatPrice(item.total_cost)}
                                                                                            {currencySymbolRight()}
                                                                                        </span>
                                                                                    </td>

                                                                                    <td className="xsm-text text-capitalize align-middle text-center text-secondary">
                                                                                        {item.note}
                                                                                    </td>

                                                                                    <td className="xsm-text text-capitalize align-middle text-center">
                                                                                        {
                                                                                            <span
                                                                                                className="btn btn-transparent btn-secondary xsm-text text-capitalize"
                                                                                                onClick={() => {
                                                                                                    handlesetdataeditcard(item)
                                                                                                    setbtncreate(false);
                                                                                                }}
                                                                                                data-toggle="modal"
                                                                                                data-target="#modalcreate"
                                                                                            >
                                                                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                                                                            </span>}
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    ),
                                                                ],
                                                            ]}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* pagination loading effect */}
                            {checkOrderDetails.uploading === true || loading === true
                                ? paginationLoading()
                                : [
                                    // logic === !searched
                                    !searchedOrder.searched ? (
                                        <div key="fragment4">
                                            <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                                                <div className="row align-items-center t-pl-15 t-pr-15">
                                                    <div className="col-md-7 t-mb-15 mb-md-0">
                                                        {/* pagination function */}
                                                        {pagination(
                                                            datatableitems,
                                                            setPaginateddatatableitems
                                                        )}
                                                    </div>
                                                    <div className="col-md-5">
                                                        <ul className="t-list d-flex justify-content-md-end align-items-center">
                                                            <li className="t-list__item">
                                                                <span className="d-inline-block sm-text">
                                                                    {showingData(datatableitems)}
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        // if searched
                                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                                            <div className="row align-items-center t-pl-15 t-pr-15">
                                                <div className="col-md-7 t-mb-15 mb-md-0">
                                                    <ul className="t-list d-flex">
                                                        <li className="t-list__item no-pagination-style">
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() =>
                                                                    setSearchedOrder({
                                                                        ...searchedOrder,
                                                                        searched: false,
                                                                    })
                                                                }
                                                            >
                                                                {_t(t("Clear Search"))}
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-md-5">
                                                    <ul className="t-list d-flex justify-content-md-end align-items-center">
                                                        <li className="t-list__item">
                                                            <span className="d-inline-block sm-text">
                                                                {searchedShowingData(
                                                                    searchedOrder,
                                                                    datatableitemsOrdersForSearch
                                                                )}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                ]}
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Desperdicio;
